import React, { useState, useEffect } from 'react'
import {
  Box,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  infoBox: {
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.grey[200]}`,
  },
  statRow: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  statItem: {
    textAlign: 'center',
    padding: theme.spacing(1),
    backgroundColor: '#fff',
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.grey[200]}`,
    flex: 1,
  },
  statValue: {
    fontSize: 18,
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  statLabel: {
    fontSize: 10,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
  },
}))

const BlurField = ({ value, onCommit, ...props }) => {
  const [local, setLocal] = useState(value || '')
  useEffect(() => { setLocal(value || '') }, [value])
  return (
    <TextField
      {...props}
      value={local}
      onChange={(e) => setLocal(e.target.value)}
      onBlur={() => { if (local !== (value || '')) onCommit(local) }}
    />
  )
}

const ServiceAreaEditor = ({ data, onChange }) => {
  const classes = useStyles()
  const propertyLines = data?.propertyLines || []

  let totalAcres = 0
  let totalSqFt = 0
  propertyLines.forEach(pl => {
    if (pl.acres) totalAcres += parseFloat(pl.acres) || 0
    if (pl.sf) totalSqFt += parseFloat(pl.sf) || 0
  })

  return (
    <Box className={classes.root}>
      <Typography variant="subtitle2" gutterBottom>
        Service Area Settings
      </Typography>

      <BlurField
        label="Headline"
        value={data?.headline || ''}
        onCommit={(v) => onChange('headline', v)}
        size="small"
        variant="outlined"
        fullWidth
      />

      <BlurField
        label="Map Caption"
        value={data?.mapCaption || ''}
        onCommit={(v) => onChange('mapCaption', v)}
        size="small"
        variant="outlined"
        fullWidth
        multiline
        rows={2}
      />

      {propertyLines.length > 0 && (
        <Box className={classes.infoBox}>
          <Typography variant="caption" style={{ color: '#666', fontWeight: 500 }}>
            Property Data (auto-populated from jobsite)
          </Typography>
          <Box className={classes.statRow}>
            {totalAcres > 0 && (
              <Box className={classes.statItem}>
                <div className={classes.statValue}>{totalAcres.toFixed(1)}</div>
                <div className={classes.statLabel}>Acres</div>
              </Box>
            )}
            {totalSqFt > 0 && (
              <Box className={classes.statItem}>
                <div className={classes.statValue}>{totalSqFt.toLocaleString()}</div>
                <div className={classes.statLabel}>Sq Ft</div>
              </Box>
            )}
            <Box className={classes.statItem}>
              <div className={classes.statValue}>{propertyLines.length}</div>
              <div className={classes.statLabel}>{propertyLines.length === 1 ? 'Parcel' : 'Parcels'}</div>
            </Box>
          </Box>
          {propertyLines[0]?.APN && (
            <Typography variant="caption" style={{ display: 'block', marginTop: 8, color: '#888' }}>
              APN: {propertyLines[0].APN}
            </Typography>
          )}
        </Box>
      )}

      {!data?.mapImageUrl && (
        <Typography variant="caption" style={{ color: '#999', fontStyle: 'italic' }}>
          Select a jobsite in the Client &amp; Site section to auto-populate the map and property data.
        </Typography>
      )}
    </Box>
  )
}

export default ServiceAreaEditor
